/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Source_OverrideInputs */

const cs_draft_source_override = /** @type {(inputs: Draft_Source_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přepsáno`)
};

const en_draft_source_override = /** @type {(inputs: Draft_Source_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Override`)
};

/**
* | output |
* | --- |
* | "Override" |
*
* @param {Draft_Source_OverrideInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_source_override = /** @type {((inputs?: Draft_Source_OverrideInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Source_OverrideInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_source_override(inputs)
	return cs_draft_source_override(inputs)
});